
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g/events",
      function () {
        return require("private-next-pages/g/events/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/g/events"])
      });
    }
  